<template>
    <b>{{ formattedTime }}</b>
</template>

<script>
import {diffTime} from "@/utils/filter";
export default {
    props: {
        currentTime: {
            type: Number,
            required: true
        },
        endTime: { 
            type: [String, Number], 
            required: true
        },
        id:{
            type: Number,
            required: true
        },
        format:{
            type: Number,
            required: 0
        }
    },
    data () {
        return {
        }
    },
    components: {},
    created () {

    },
    watch: {},
    computed: {
        remainingTime(){
            return Math.max(0, this.endTime - this.currentTime)
        },
        formattedTime() {
            if(this.currentTime>=this.endTime){
                this.$emit('over', this.id);
                return null
            }
            let timeDiff=diffTime(this.currentTime,this.endTime);
            let{days,hours,minutes,seconds}=timeDiff
            if(this.format==1){
                return this.formatNum(hours)+':'+this.formatNum(minutes)+':'+this.formatNum(seconds)
            }else{
                return this.formatNum(days)+'天'+this.formatNum(hours)+'小时'+this.formatNum(minutes)+'分钟'+this.formatNum(seconds)+'秒'
            }
            
        },
    },
    mounted () {
        this.$emit('countNum', this.id);
    },
    methods: {
        formatNum (num) {
            return num < 10 ? '0' + num : '' + num
        },
    }
}
</script>

<style lang='less' scoped>
</style>
